import { PreviewPanelDetailRow } from "components/Atoms/details/PreviewPanelDetailRow";
import equal from "fast-deep-equal";
import React, { useEffect, useState } from "react";
import { ExclusivityConflictsModal } from "./ExclusivityConflictsModal";
import { ExclusivityCheckResultMessage, ExclusivityClauseDetailsForPreviewPanel } from "./ExclusivityClauseMessages";
import { countExclusivityConflicts, ExclusivityCheckFields, ExclusivityCountResult } from "./utils";

interface ExclusivityConflictsForShowPreviewPanelProps {
  show: server.dto.Show
  exclusivityCheckFields: ExclusivityCheckFields
}

export const ExclusivityConflictsForShowPreviewPanel = (props: ExclusivityConflictsForShowPreviewPanelProps) => {
  const [isExclusivityConflictsModalOpen, setIsExclusivityConflictsModalOpen] = useState(false);
  const [exclusivityCheckFields, setExclusivityCheckFields] = useState(props.exclusivityCheckFields);
  const [result, setResult] = useState<ExclusivityCountResult>({
    exclusivityConflictErrors: [],
    schedulingConflictErrors: [],
    exclusivityConflictsCount: 0,
    scheduleConflictsCount: 0,
  });

  // A slightly complex pair of use effects. This makes sure a refetch is only tirggered when the value of any of the fields changes
  useEffect(() => {
    const fetchConflicts = async () => {
      const exclusivityConflictResult = await countExclusivityConflicts(exclusivityCheckFields, false);
      setResult(exclusivityConflictResult);
    }
    fetchConflicts();
  }, [exclusivityCheckFields])

  useEffect(() => {
    if (!equal(props.exclusivityCheckFields, exclusivityCheckFields)) {
      setExclusivityCheckFields(props.exclusivityCheckFields);
    }
  }, [props.exclusivityCheckFields]);

  return <>
    <ExclusivityConflictsModal
      isOpen={isExclusivityConflictsModalOpen}
      handleClose={() => setIsExclusivityConflictsModalOpen(false)}
      activeShow={props.show}
      exclusivityCheckFields={exclusivityCheckFields}
    />
    <PreviewPanelDetailRow
      labelTop={RESX.Exclusivity.resxExclusivity}
    >
      <ExclusivityClauseDetailsForPreviewPanel
        result={result}
        clause={exclusivityCheckFields.exclusivityClause}
      />
      <ExclusivityCheckResultMessage
        wrapperClassName="exclusivity-message-wrapper-preview-panel"
        openExclusivityConflictModal={() => setIsExclusivityConflictsModalOpen(true)}
        result={result}
      />
    </PreviewPanelDetailRow>
  </>
}
